<template>
  <div class="d-flex pb-2 justify-end mb-2">
    <slot name="top-search-area" />
  </div>
  <div class="d-flex pb-2 justify-space-between">
    <div class="d-flex align-center justify-start" style="width: 50%">
      <p class="font-weight-medium mr-1" style="color: grey">Total Count:</p>
      <p class="font-weight-bold mr-5" style="color: grey; font-size: 13px">{{ totalCnt }}</p>
      <v-select
        v-if="!hideRowPerPage"
        :items="rowsPerPageOptions"
        v-model="rowPerPage"
        style="width: 180px; flex: inherit"
      />
    </div>
    <div class="d-flex align-center justify-end" style="width: 50%">
      <!-- template v-slot:top-btn-area (S) -->
      <slot name="top-btn-area"></slot>
      <!-- template v-slot:top-btn-area (E) -->
    </div>
  </div>

  <v-divider />

  <div class="d-flex py-2 justify-space-between">
    <div class="d-flex align-center justify-start" style="width: 50%">
      <!-- template v-slot:left-btn-area (S) -->
      <div class="d-flex align-center justify-start">
        <!-- checked 상태일 때만 나오는 체크된 갯수 -->
        <p v-if="checked" class="font-weight-medium mr-2" style="color: grey">
          {{ validationCheckedCnt }}
        </p>
        <slot name="left-btn-area"> </slot>
      </div>
      <!-- template v-slot:left-btn-area (E) -->
    </div>
    <div class="d-flex align-center justify-end" style="width: 50%">
      <!-- template v-slot:right-btn-area (S) -->
      <slot name="right-btn-area"></slot>
      <!-- template v-slot:right-btn-area (E) -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onBeforeMount, ref, watch } from "vue";
import { global, i18n } from "@/app/plugins/global";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
const vm = global();
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedRowPerPage = defineModel("rowPerPage", { type: Number, required: true });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  totalCnt: { type: Number, required: true },
  checked: { type: Boolean, default: false },
  checkedCnt: { type: Number, default: 0 },
  hideRowPerPage: { type: Boolean, default: false },
  rowsOptionType: { type: String, default: "md" }, // "sm": [5, 10, 50, 100, all], "md": [10, 20, 50, 100, all]
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
const DEFAULT_ROW_PER_PAGE = 10;

const rowPerPage = ref<number | null>(DEFAULT_ROW_PER_PAGE);
/** 행 수 옵션 */
const rowsPerPageOptions = computed(() => {
  if (props.rowsOptionType === "sm") {
    return [
      { title: $text("table.row5"), value: 5 },
      { title: $text("table.row10"), value: 10 },
      { title: $text("table.row50"), value: 50 },
      { title: $text("table.row100"), value: 100 },
      { title: $text("table.rowAll"), value: 0 },
    ];
  } else {
    return [
      { title: $text("table.row10"), value: 10 },
      { title: $text("table.row20"), value: 20 },
      { title: $text("table.row50"), value: 50 },
      { title: $text("table.row100"), value: 100 },
      { title: $text("table.rowAll"), value: 0 },
    ];
  }
});

/** 선택된 갯수 가져오기 */
const validationCheckedCnt = computed(() => {
  return props.checked ? `${props.checkedCnt}개 선택` : "";
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
onBeforeMount(() => {
  rowPerPage.value = selectedRowPerPage.value;
});

watch(
  () => rowPerPage.value,
  (newVal, oldVal) => {
    if (newVal === null || newVal === 0) {
      vm.$confirm($text("table.message.searchAll"), $text("confirm.noty"), (isConfirm: boolean) => {
        selectedRowPerPage.value = isConfirm ? 0 : oldVal || DEFAULT_ROW_PER_PAGE;
        rowPerPage.value = isConfirm ? 0 : oldVal || DEFAULT_ROW_PER_PAGE;
      });
    } else {
      selectedRowPerPage.value = newVal;
    }
  }
);
</script>
